import { queryBot2 } from 'boot/axios';

async function readDisableGlobal ({ store }) {
    // await queryBot('select * from meta where param = "platform-settings" limit 1').then(async (r) => {
    await queryBot2('readDisableGlobal', { param: 'platform-settings' }).then(async (r) => {
        if (!r.data || typeof r.data !== 'object') {
            return;
        }
        const [data] = r.data;
        const { value } = data;
        if (!value) {
            return;
        }
        const json = JSON.parse(value);
        if (typeof json === 'object') {
            await store.commit('projects/setDisable', json.projectsModule !== true);
        }
    });
}

async function readDisableAddition ({ store, user }) {
    // custom conditions to block project module for no superusers and no testusers
    let disable = true;
    if (user && typeof user === 'object') {
        const isSu = user.is_superuser === '1';
        const isTest = user.is_test === '1';
        const allowFlows = [40, 41, 42, 43, 44];
        await queryBot2('readDisableAddition', { courseId: user.last_course_id, userId: user.id }).then((r) => {
            const [row] = r.data;
            if (row) {
                const inFlows = allowFlows.filter(i => i === parseInt(row.flow_id, 10)).length > 0;
                disable = (!inFlows || !isSu) && !isTest;
                // console.log('in front logic', inFlows, isSu, disable);
                // console.log('more...');
                // console.log('user.is_superuser:', user.is_superuser);
                // console.log('row.flow_id:', row.flow_id);
                // console.log('filter work:', allowFlows.filter(i => { console.log('i>', i); return i === parseInt(row.flow_id, 10); }));
                // console.log('allowFlows.filter:', allowFlows.filter(i => i === parseInt(row.flow_id, 10)));
                // console.log('...end');
            }
        });
    }

    const { isCreate, isShow } = store.state.projects.allows;
    const result = !disable && !isCreate && !isShow ? true : disable;
    await store.commit('projects/setDisable', result);
}

async function readDisableProd ({ store }) {
    const { isCreate, isShow } = store.state.projects.allows;
    if (!isCreate && !isShow) {
        await store.commit('projects/setDisable', true);
    }
}

export async function disableProjects ({ store, user }) {
    const test = false;
    await readDisableGlobal({ store });
    // console.log('+0', test, user, store.state.projects);
    if (user !== true && !store.state.projects.disable) {
        if (test) {
            // console.log('+1');
            await readDisableAddition({ store, user });
        } else {
            // console.log('+2');
            await readDisableProd({ store });
        }
    }
}

export default disableProjects;
